import { LEGEND_HEIGHT_OFFSET } from '@occc/ui-design-system';

export const CHART_HEIGHT = 180;
export const CHART_HEIGHT_WITH_LEGEND = CHART_HEIGHT + LEGEND_HEIGHT_OFFSET;
